import { Link } from "react-router-dom";
import { PickPasteProfitDemo } from "../PickPasteProfitDemo";
import { LandingFoundersPick } from "./LandingFoundersPick";

export const LandingProductPreview = () => (
  <section className="border-b border-white/10 bg-[#030206]" data-testid="landing-product-preview">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:px-10 lg:py-24">
      <div className="max-w-3xl">
        <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-purple-300">Inside the vault</div>
        <h2 className="mt-4 font-display text-3xl font-black leading-[1.05] text-white sm:text-4xl">See the workflow before you pay for it.</h2>
        <p className="mt-4 text-base leading-relaxed text-zinc-300">Pick a track, run each prompt in order, ship the output. This is the actual vault flow, illustrated live.</p>
      </div>
      <div className="mt-9 max-w-5xl">
        <PickPasteProfitDemo />
        <div className="mt-3 flex flex-wrap items-center justify-between gap-2 font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-600">
          <span>Actual vault workflow · illustrated live</span>
          <span>Pick → run → ship</span>
        </div>
        <LandingFoundersPick />
      </div>
      <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-xs uppercase tracking-[0.16em] text-zinc-500">
        <Link to="/quiz" className="min-h-11 py-3 transition-colors hover:text-amber-200" data-testid="hero-cta-quiz">Not sure where to start? Take the 60-sec quiz →</Link>
        <Link to="/about" className="min-h-11 py-3 transition-colors hover:text-purple-300" data-testid="hero-cta-manifesto">Why Stag Vault exists →</Link>
      </div>
    </div>
  </section>
);
